"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallNotificationListener = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const rxjs_1 = require("../hooks/rxjs");
const fullscreen_portal_1 = require("../components/fullscreen_portal");
const call_notification_1 = require("../components/incoming_calls/call_notification");
const user_session_1 = require("../context/user_session");
const logger_1 = require("../util/logger");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const CallNotificationListener = ({ userSession, callConfig, autoAcceptInvites, SystemNotificationComponent, handleAnswerCallError = () => { }, }) => {
    const [pendingInvitation] = (0, rxjs_1.useObservable)(userSession.currentPendingInvitation);
    const [availabilityStatus] = (0, rxjs_1.useObservable)(userSession.currentAvailabilityStatus);
    const UserSessionProvider = (0, user_session_1.createUserSessionProvider)(userSession);
    const answerCall = () => __awaiter(void 0, void 0, void 0, function* () {
        if (pendingInvitation) {
            try {
                yield userSession.acceptInvitation(pendingInvitation, callConfig);
            }
            catch (error) {
                logger_1.logger.error(`Error accepting invitation: ${error}`);
                handleAnswerCallError();
            }
        }
    });
    const rejectCall = () => __awaiter(void 0, void 0, void 0, function* () {
        if (pendingInvitation) {
            yield userSession.rejectInvitation(pendingInvitation);
        }
    });
    // This useEffect is meant to replicate componentDidMount
    (0, react_1.useEffect)(() => {
        logger_1.logger.info(`CallNotificationListener component initialized. ${pendingInvitation ? `pendingInvitationId=${pendingInvitation.id}` : ''}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(() => {
        if ((pendingInvitation === null || pendingInvitation === void 0 ? void 0 : pendingInvitation.status) === 'PENDING' && autoAcceptInvites) {
            answerCall();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoAcceptInvites, pendingInvitation]);
    const availabilityStatusNotAvailable = (availabilityStatus === null || availabilityStatus === void 0 ? void 0 : availabilityStatus.availabilityStatus) ===
        streem_sdk_protobuf_1.streem.api.AvailabilityStatus.AVAILABILITY_STATUS_NOT_AVAILABLE;
    return ((0, jsx_runtime_1.jsx)(fullscreen_portal_1.FullscreenPortal, Object.assign({ className: "IncomingCallPortal" }, { children: (0, jsx_runtime_1.jsx)(UserSessionProvider, { children: (pendingInvitation === null || pendingInvitation === void 0 ? void 0 : pendingInvitation.status) === 'PENDING' &&
                !autoAcceptInvites &&
                !availabilityStatusNotAvailable ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(call_notification_1.CallNotification, { roomInvitation: pendingInvitation, onAnswer: answerCall, onReject: rejectCall, brandSettings: callConfig.brandSettings, showReservationCallDetailYn: !!callConfig.showReservationCallDetailYn }), SystemNotificationComponent && ((0, jsx_runtime_1.jsx)(SystemNotificationComponent, { invitation: pendingInvitation }))] })) : null }) })));
};
exports.CallNotificationListener = CallNotificationListener;
//# sourceMappingURL=call_notification_listener.js.map